import { LandingComponentsConfig, LandingScreenSchema } from '@/modules/Landing/instances/@types/landing-types'
import militaryAge18Png from '@/assets/landing-activity-male/military-18.png'
import militaryAge30Png from '@/assets/landing-activity-male/military-30.png'
import militaryAge40Png from '@/assets/landing-activity-male/military-40.png'
import militaryAge50Png from '@/assets/landing-activity-male/military-50.png'

const schema: LandingScreenSchema = {
	order: ['LandingHead', 'LandingTitle', 'LandingSubtitle', 'LandingAgeGrid'],

	components: {
		LandingTitle: (): LandingComponentsConfig['LandingTitle'] => ({
			title: 'MILITARY CALISTHENICS PLAN',
			uppercase: true,
			size: 'large',
			customStyles: {
				marginLeft: '1rem',
				marginRight: '1rem',
			},
		}),

		LandingSubtitle: (): LandingComponentsConfig['LandingSubtitle'] => ({
			uppercase: true,
			title: 'BASED ON YOUR AGE',
		}),

		LandingAgeGrid: (): LandingComponentsConfig['LandingAgeGrid'] => ({
			theme: 'military',
			ageRanges: [
				{
					value: 18,
					analyticValue: '18-29',
					label: 'Age: 18-29',
					img: militaryAge18Png,
				},
				{
					value: 30,
					analyticValue: '30-39',
					label: 'Age: 30-39',
					img: militaryAge30Png,
				},
				{
					value: 40,
					analyticValue: '40-49',
					label: 'Age: 40-49',
					img: militaryAge40Png,
				},
				{
					value: 50,
					analyticValue: '50-59',
					label: 'Age: 50+',
					img: militaryAge50Png,
				},
			],
		}),
	},
}

export default schema
